<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
  <div class="row g-0 m-0 p-4 justify-content-start borderb">
    <div class="col-md-11 ps-2 d-flex justify-content-start">
      <span class="popup-title">{{ "REMINDER_DETAILS" | translate }}</span>
    </div>
    <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
      <svg-icon class="exit" role="button" src="assets/device/exit.svg" alt="Exit"></svg-icon>
    </div>
  </div>
  <div class="row g-0 m-0 body p-4 pt-5">
    <div class="member-details p-4">
      <div class="row g-0 m-0">
        <div class="row d-flex g-0 p-0">
          <span class="item-title pb-5 pt-2">{{ reminder.name }} </span>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "TIMEPERIOD" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ reminder.cron| cron}}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "DEVICESETUP_ASSETTYPE" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ assetTypeNames.join(', ') || '/' }}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "DEVICESETUP_METERMODEL" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ meterModelNames.join(', ') || '/' }}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "DEVICESETUP_REGION" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ reminder.regionNames?.join(', ') || "/" }}</span>
          </div>
        </div>
        <div class="row g-0 m-0 pt-2 pb-2">
          <div class="col-md-6">
            <span class="item-name">{{ "DEVICESETUP_AREA" | translate }}</span>
          </div>
          <div class="col-md-6">
            <span class="item-info">{{ reminder.areaNames?.join(', ') || '/' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
    <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
      <span role="button" class="item-name">{{
        "CLOSE_WINDOW" | translate
        }}</span>
    </div>
  </div>
</div>
